export default __webpack_public_path__ + "static/media/26_CISA.c82cf4b1.png";